import { HOTEL_LIST } from "@elit-hair/elitklinik-shared";
import { GridColDef, getGridSingleSelectOperators } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { TbBuildingSkyscraper } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import TableListItem from "@/components/table/TableListItem";
import { OperationHotelResponseType } from "@/types/hotel.types";

type HotelImageProps = {
    src: string;
    alt: string;
    cancelled: boolean;
};

function HotelImage({ src, alt, cancelled }: HotelImageProps) {
    return (
        <div
            className={
                "relative overflow-hidden rounded-md  ring-1 ring-slate-200  shadow-sm h-7  aspect-video " +
                (cancelled ? "bg-red-50" : "bg-white")
            }
        >
            <img src={src} alt={alt} className="h-full w-full object-contain p-1" />
        </div>
    );
}

function Hotel({ value, cancelled }: { value: string; cancelled: boolean }) {
    const hotel = value && HOTEL_LIST.find((item) => item.name === value);

    return (
        <div className="flex items-center p-1 h-full  ">
            <TableListItem>
                {hotel ? (
                    <div className="flex items-center gap-2 w-full">
                        <HotelImage cancelled={cancelled} src={hotel.logo} alt={hotel.name} />
                        <span className="truncate text-sm font-semibold">{hotel.name}</span>
                    </div>
                ) : (
                    <div className={"flex items-center gap-2 " + (cancelled ? " text-red-800" : "text-slate-500")}>
                        <TbBuildingSkyscraper />
                        <span className="text-sm">Otel seçilmedi</span>
                    </div>
                )}
            </TableListItem>
        </div>
    );
}

export const HotelNameColumn = ({
    t,
}: {
    t: TFunction;
}): GridColDef<
    OperationHotelResponseType<string, "local"> & {
        hotelName: string;
        hotel: string;
    }
> => {
    return {
        field: "accommodation",
        headerName: t("accomodation"),
        minWidth: 200,
        maxWidth: 350,
        flex: 0.5,
        filterable: false,
        valueGetter: (_, row) => row.pickupLocation || row.hotelName || row.hotel || "",
        filterOperators: getGridSingleSelectOperators(),
        valueOptions: HOTEL_LIST.map((item) => ({ id: item.name, label: item.name })),
        renderHeader: (params) => <TableHeader Component={TbBuildingSkyscraper} title={params.colDef.headerName!} />,
        renderCell: ({ value, row }) => <Hotel cancelled={!!row.cancelled} value={value} />,
    };
};
export default HotelNameColumn;
